import gql from 'graphql-tag';

export const DEALER_TIERS_OPTIONS = gql`
  query DealerTiersOptions {
    result: dealerTierOptions {
      error
      success
      list {
        label
        value
      }
    }
  }
`;
